<template>
  <div>
    <h2 class="text-base font-medium mb-3">
      {{ $t('Services.AddedOrders') }}
    </h2>
    <div class="flex flex-col gap-3">
      <Card
        v-for="order in serviceOrders"
        :key="order.id"
        :title="order.service_provider.name"
        :subtitle="order.bookable.name"
        selected
        :action="
          order.is_editable ? {
            label: $t('Services.Details.Delete'),
            danger: true,
            icon: Trash2,
            onClick: () => deleteOrder(order),
          } : {
            label: $t('Services.Details.Revoke'),
            danger: true,
            icon: RotateCcw,
            onClick: () => revokeOrder(order),
          }"
        @open="$emit('edit', order)"
      >
        <template #details>
          <ServiceOrderStatus :status="order.status" /> {{ totalPrice(order) }} €, {{ $tc('Services.Items', totalItems(order)) }}
        </template>
      </Card>
    </div>
    <div class="divider my-4" />
  </div>
</template>

<script>
import api from '@/lib/api'
import ServiceOrderStatus from './ServiceOrderStatus.vue'
import { useNotify } from '@/composables/notify'
import { RotateCcw, Trash2 } from 'lucide-vue'
import { useConfirmDialog } from '@/composables/confirmDialog'
import Card from './Card.vue'

export default {
  components: {
    ServiceOrderStatus,
    Card,
  },
  props: {
    serviceOrders: { type: Array, required: true },
  },
  setup () {
    return {
      ...useNotify(),
      ...useConfirmDialog(),
    }
  },
  data: () => ({
    Trash2,
    RotateCcw,
  }),
  methods: {
    totalItems (order) {
      return order.items.reduce((acc, cur) => acc + cur.quantity, 0)
    },
    totalPrice (order) {
      return order.items.reduce((acc, cur) => acc + cur.price * cur.quantity, 0)
    },
    async deleteOrder (order) {
      try {
        if (!await this.confirm({
          danger: true,
        })) {
          return
        }
        await api.deleteServiceOrder(order.id)
        this.success(this.$t('Success.OrderDeleted'))
      } catch {}
      this.$emit('delete')
    },
    async revokeOrder (order) {
      try {
        if (!await this.confirm({
          danger: true,
        })) {
          return
        }
        await api.revokeServiceOrder(order.id)
        this.success(this.$t('Success.OrderRevoked'))
      } catch {}
      this.$emit('delete')
    },
  },
}
</script>
